import { PostJobStep } from '../../../../../store/workspace/types';
import MotionWrapper from '../../../../../layouts/MotionWrapper';
import { ListItem } from '../../../../../store/general/types';
import { codingLanguagesList } from '../../../../../configs';
import DropDown from '../../../../../components/DropDown';
import Button from '../../../../../components/Button';
import Toggle from '../../../../../components/Toggle';
import Chips from '../../../../../components/Chips';
import { Dispatch, SetStateAction } from 'react';
import styles from './style.module.scss';

interface Props {
    codingExam: boolean;
    codingExamLanguages: ListItem[];
    setStep: (step: PostJobStep) => void;
    setCodingExam: Dispatch<SetStateAction<boolean>>;
    updateCodingExamLanguages: (item: ListItem, action: 'Add' | 'Remove') => void;
};

export default function CodingExamDetail(props: Props) {
    const {
        codingExam,
        codingExamLanguages,
        setStep,
        setCodingExam,
        updateCodingExamLanguages,
    } = props;

    return (
        <MotionWrapper className={styles.container}>
            <span className={styles.title}>
                Post new job - Coding exam
            </span>
            <div className={styles.activate}>
                <span className={styles.activate_title}>
                    Generate coding exam
                </span>
                <Toggle
                    toggled={codingExam}
                    setToggle={() => setCodingExam(prev => !prev)}
                />
            </div>
            {codingExam && (<>
                <span className={styles.description}>
                    Select up to <b>4</b> programming languages to offer
                    as choices to the applicant for the <b>coding exam</b>.
                </span>
                <div className={styles.content}>
                    <DropDown
                        idKey='id'
                        resetable
                        titleKey='title'
                        selectedItem={null}
                        dropDownList={codingLanguagesList}
                        placeholder='programming languages'
                        setItem={(item: ListItem) => updateCodingExamLanguages(item, 'Add')}
                    />
                    <div className={styles.content_chips_box}>
                        {codingExamLanguages
                            .map(item => <Chips
                                title={item.title}
                                removeFunc={() => updateCodingExamLanguages(item, 'Remove')}
                            />)}
                    </div>
                </div>
            </>)}
            <div className={styles.actions}>
                <Button
                    text='Back'
                    type='Outline-Primary'
                    className={styles.actions_btn}
                    onClick={() => setStep('MultipleChoiceExamDetail')}
                />
                <Button
                    type='Primary'
                    text='Continue'
                    className={styles.actions_btn}
                    onClick={() => setStep('ExamDeadline')}
                    disabled={codingExam && codingExamLanguages.length === 0}
                />
            </div>
        </MotionWrapper>
    )
};
